import { FC, ReactNode } from 'react'

import { isMobile } from 'services/Utilities'
import { ButtonGroup } from 'ui'

type Props = {
  className?: string
  children?: ReactNode
  size?: 'sm' | 'lg'
}
const AutomaticButtonGroup: FC<Props> = ({ size, children, className }) => {
  return (
    <ButtonGroup className={className} size={size} vertical={!!isMobile()}>
      {children}
    </ButtonGroup>
  )
}

export default AutomaticButtonGroup
